var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',{attrs:{"show":Boolean(_vm.topAlert.message),"variant":_vm.topAlert.variant}},[_vm._v("\n  "+_vm._s(_vm.topAlert.message)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }